function submenu() {
    $('.submenu-options a[data-preview]').hover(function () {
        const previewContainer = $(this).closest('.submenu').find('.category-preview-container');
        //console.log($(this).attr('data-preview'));
        //console.log(previewContainer);

        previewContainer.find('.category-preview').removeClass('show');
        previewContainer.find($(this).attr('data-preview')).addClass('show');
    });
}

export default submenu;